import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useState } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";
import UserOnglet from "../../user/UserOnglet";

const HelpTopicTrouverRecu = () => {
  const { windowWidth, setOngletPaiementActif } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  const [ongletActif, setOngletActif] = useState('');
  useEffect(() => {   // permet d'initialiser l'onglet actif paiement a null pour cette section
    setOngletPaiementActif(null)
  }, [])

  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Factures et reçus', link: '/topics/paiement/factures'},
    { label: topic.title, link: topic.link},
  ];


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Vous avez besoin de documents ? Aucun problème. Vous pouvez télécharger, imprimer ou envoyer votre reçu par e-mail depuis votre ordinateur ou votre navigateur.
            </p>
            <UserOnglet
              onglets={[{label: 'Ordinateur de bureau', id: 1}, {label: 'Navigateur mobile', id: 2}]} 
              ongletActif={ongletActif} setOngletActif={setOngletActif}
            />
            {ongletActif.id === 1
              ? <div className="mt-32">
                  <ol>
                    <li className="pl-8 mb-8">
                      <p className="help-text">Cliquez sur <strong>Profil</strong> {'>'}
                      <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/payments`}>Paiements et versements.</a></p>
                    </li>
                    <li className="pl-8 mb-8">
                      <p className="help-text">
                        Cliquez sur le bouton <strong>Gérer les paiements</strong>
                      </p>
                    </li>
                    <li className="pl-8 mb-8">
                      <p className="help-text">Sélectionnez la compétition pour laquelle vous souhaitez obtenir un reçu.</p>
                    </li>
                    <li className="pl-8 mb-8"><p className="help-text">Cliquer sur le bouton <i className="bi bi-filetype-pdf fz-20 ml-8"></i>.</p></li>
                  </ol>
                </div>
              : <div className="mt-32">
                  <ol>
                    <li className="pl-8 mb-8">
                      <p className="help-text">Appuyer sur <strong>Profil</strong> {'>'}
                      <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/payments`}>Paiements et versements.</a></p>
                    </li>
                    <li className="pl-8 mb-8">
                      <p className="help-text">
                        Appuyer sur le bouton <strong>Gérer les paiements</strong>
                      </p>
                    </li>
                    <li className="pl-8 mb-8">
                      <p className="help-text">Sélectionnez la compétition pour laquelle vous souhaitez obtenir un reçu.</p>
                    </li>
                    <li className="pl-8 mb-8"><p className="help-text">Appuyer sur le bouton <i className="bi bi-filetype-pdf fz-20 ml-8"></i>.</p></li>
                  </ol>
                </div>
            }
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicTrouverRecu